import { Flex, Spinner, Text } from "@chakra-ui/react"; 

const CheckoutLoading = () => {
  return (
    <Flex w="full" h="full" justifyContent="center" alignItems="center" py="4" flexDir="column" gap="4">
      <Spinner size="lg" color="red.500" />

      <Text 
        fontSize="1.25rem" 
        fontWeight="600" 
        textAlign="center"
        color="white.95"
        fontFamily="heading"
      >
        We are processing your payment!
      </Text>
      <Text 
        fontSize="1rem" 
        fontWeight="400" 
        textAlign="center"
        color="white.80"
        fontFamily="body"
      >
        Your purchase will be completed shortly.
      </Text>
    </Flex>
  );
};

export default CheckoutLoading;